import { Box } from 'rebass/styled-components';
import styled from 'styled-components';
import { space } from 'styled-system';
export default styled(Box).withConfig({
  displayName: "info-box",
  componentId: "sc-pxl0wz-0"
})(["background-color:#eff9f2;border:1px solid #bfded2;border-radius:4px;color:#6d8d76;font-size:12px;line-height:1.5;padding:8px 14px 8px 14px;", " b{font-weight:bold;}&.yellow{border:solid 1px #d8d5ba;background-color:#fffdeb !important;color:#75725b;}"], space);